import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { GridActionsCellItem } from '@mui/x-data-grid';
import * as icons from 'react-bootstrap-icons';
import Inputer from 'Utils/Helpers/Inputer';
import CButton from 'Utils/Helpers/CButton';
import { useSetState } from 'Utils/Helpers/Hooks';
import { useSelector, useDispatch } from 'react-redux';
import { editAuth, users_data } from 'http/components/UserService';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetUsersData } from 'Utils/Helpers/HandleApiData';
import { enqueueSnackbar } from 'notistack';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditUserPass({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { current } = useSelector((state) => ({
    current: state.staff.current,
  }));
  const [controls, setControls] = useSetState ({
    user_name: {
      id: "user_name",
      type: 'text',
      placeholder: 'نام کاربری',
      value: '',
      icon: <icons.Person/>,
    },
    pass_word: {
      id: "pass_word",
      type: 'password',
      placeholder: 'رمز عبور',
      value: '',
      icon: <icons.Key/>,
    },
  });

  const onEnter = () => {
    setControls({ user_name: { value: row.userName } });
  }

  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  const setShowDialog = () => {
    setShow(true);
  }

  const handleClose= () => {
    setShow(false);
  }

  const onFinish = async () => {
    const {user_name, pass_word} = controls;
    dispatch(HandleLoading(true));
    if(user_name.value !== '' && pass_word.value !== '') {
      const response = await editAuth(row.id, user_name.value, pass_word.value);
      if(response.status) {
        const response2 = await users_data();
        if(response2.status) {
            await dispatch(SetUsersData(response2.data))
            enqueueSnackbar('اطلاعات کاربر با موفقیت ویرایش شد', {variant: 'success'});
            setShow(false);
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
      <GridActionsCellItem
        icon={<icons.Key size={16}/>}
        label="Edit"
        onClick={setShowDialog}
        disabled={!current[3][3]}
        hidden={!current[3][3]}
      />
      {
        show &&
        <Dialog
            open={show}
            TransitionComponent={Transition}
            keepMounted
            fullWidth={true}
            maxWidth={'xs'}
            onClose={handleClose}
            TransitionProps={{onEnter: onEnter}}
            aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className='edit-mode'>
            {`اطلاعات ورود ${row.name.substring(0, row.name.indexOf(" "))}`}
            <div className='close-btn' onClick={handleClose}>
                <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            {
              show &&
              <DialogContentText id="alert-dialog-slide-appointment-edit">
                {
                  Object.keys(controls).map((key, index) => {
                    return (
                      <Inputer
                        key={`inputer_${controls[key].id}`}
                        id={controls[key].id}
                        type={controls[key].type}
                        placeholder={controls[key].placeholder}
                        value={controls[key].value}
                        setValue={setControlsValue.bind(this)}
                        icon={controls[key].icon}
                        className={'mb-2'}
                      />
                    )
                  })
                }
              </DialogContentText>
            }
          </DialogContent>
          <DialogActions>
            <CButton
              text={'ویرایش کاربر'}
              icon={<icons.Pencil/>}
              onClick={onFinish}
            />
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
